import "core-js/modules/es.array.includes.js";
import { addEvent } from './includes/_events';
import { QuantitySelector } from './includes/_quantity-selector.class';
import { QuantityUpdater } from './includes/_quantity-updater';
import { MediaCarousel } from './includes/_carousel';
const SUCCESS_MESSAGE_DISPLAY_TIMER = 3000;
const addToCartButtonStyle = Object.freeze({
  Success: 'mc-button--outlined'
});
const addToCartButtonImage = Object.freeze({
  Default: '#business_cart_24',
  Success: '#ui_check_24'
});
function addToCartBundle(containerSelector, self) {
  const thumbnailsContainer = document.querySelector(containerSelector);
  if (!thumbnailsContainer) {
    return;
  }
  const quantitySelectorsWithoutAtc = thumbnailsContainer.querySelectorAll('.js-thumbnail-quantity-selector-without-atc');
  const listProducts = [];
  for (let quantitySelector of quantitySelectorsWithoutAtc) {
    const addToCartForm = quantitySelector.querySelector('.js-thumbnail-add-to-cart-form');
    if (addToCartForm) {
      const productElement = buildProductElement(addToCartForm, false);
      if (productElement) {
        listProducts.push(productElement);
      }
    }
  }
  if (listProducts.length === 0) {
    return;
  }
  self.cartUpdate({
    listProducts
  });
}
function buildProductElement(form, lightMode) {
  if (!form) {
    return null;
  }
  const quantity = form.querySelector('input[name="quantity"]');
  const requestQuantity = quantity ? quantity.value : 1;
  const productIdentifier = form.querySelector('input[name="reflm"]').value;
  const offerId = form.querySelector('input[name="offerId"]').value;
  const contextCode = form.querySelector('input[name="contextCode"]').value;
  const atcButtonLocation = form.querySelector('input[name="atcButtonLocation"]').value;
  return {
    quantity: requestQuantity,
    reflm: productIdentifier,
    offerId,
    contextCode,
    atcButtonLocation,
    ...(lightMode && {
      lightMode,
      atcForm: form
    })
  };
}
async function addToCart(form, lightMode, eventTarget, self) {
  eventTarget.preventDefault();
  const productElement = buildProductElement(form, lightMode);
  if (!productElement) {
    return;
  }
  self.cartUpdate({
    listProducts: [productElement]
  });
}
function displayQuantitySelector(parentEl, display = true) {
  if (!parentEl) {
    return;
  }
  const isMobile = window.matchMedia('(min-width: 680px)');
  const overlayEl = parentEl.querySelector('.js-quantity-overlay');
  const wrapperEl = parentEl.querySelector('.js-thumbnail-quantity-selector-wrapper');
  if (!overlayEl || !wrapperEl) {
    return;
  }
  if (!isMobile.matches) {
    document.documentElement.classList.toggle('is-scroll-locked', display);
  }
  overlayEl.classList.toggle('is-visible', display);
  wrapperEl.classList.toggle('kl-hidden', !display);
}

/**
 * Keep the quantity value of two quantity selector forms synchronized (silent form and its
 * AJAX-loaded counterpart), whichever is changed first.
 */
function linkQuantitySelectorValues(formA, formB) {
  const syncQuantity = (source, target) => {
    const sourceInput = source.querySelector('.js-control');
    const targetInput = target.querySelector('.js-control');
    if (!sourceInput || !targetInput || sourceInput.value === targetInput.value) {
      return;
    }
    targetInput.value = sourceInput.value;
    targetInput.dispatchEvent(new Event('keyup', {
      bubbles: true
    }));
    target.dispatchEvent(new Event('THUMBNAIL_USER_QUANTITY_UPDATED'));
  };
  formA.addEventListener('THUMBNAIL_USER_QUANTITY_UPDATED', () => syncQuantity(formA, formB));
  formB.addEventListener('THUMBNAIL_USER_QUANTITY_UPDATED', () => syncQuantity(formB, formA));
  syncQuantity(formA, formB);
}
function resetQuantitySelectorVisibility() {
  const thumbnailsEl = document.querySelectorAll('.o-thumbnail');
  for (const el of thumbnailsEl) {
    displayQuantitySelector(el, false);
  }
}
function handleSuccessMessage(form) {
  const svgElement = form.querySelector('.js-thumbnail-add-to-cart-light-form svg use');
  const buttonAddToCart = form.querySelector('.js-thumbnail-add-to-cart-light-form button');
  const successMessage = form.querySelector('.product-thumbnails-add-to-cart-msg');

  // TODO for ab test we hide QS to display success message, how to do better ?
  const quantitySelectorForm = form.parentNode?.querySelector('.js-thumbnail-standard-quantity-selector');
  const isNewQuantitySelector = quantitySelectorForm?.dataset.newQuantitySelector === 'true';
  if (quantitySelectorForm && !isNewQuantitySelector) {
    quantitySelectorForm.classList.add('kl-hidden');
  }
  displaySuccessMessageAndPutCheckIcon(successMessage, svgElement, buttonAddToCart);
  setTimeout(() => putBackCartIcon(svgElement, buttonAddToCart), SUCCESS_MESSAGE_DISPLAY_TIMER);
}
function displaySuccessMessageAndPutCheckIcon(successMessage, svgElement, buttonAddToCart) {
  successMessage.classList.remove('kl-hidden');
  if (svgElement) {
    const href = svgElement.getAttribute('href');
    const prefix = href.substring(0, href.indexOf('#'));
    svgElement.setAttribute('href', prefix + addToCartButtonImage.Success);
    buttonAddToCart.classList.add(addToCartButtonStyle.Success);
  }
}
function putBackCartIcon(svgElement, buttonAddToCart) {
  if (svgElement) {
    const href = svgElement.getAttribute('href');
    const prefix = href.substring(0, href.indexOf('#'));
    svgElement.setAttribute('href', prefix + addToCartButtonImage.Default);
    buttonAddToCart.classList.remove(addToCartButtonStyle.Success);
  }
}
function handleErrorMessage(form) {
  const errorMessage = document.querySelector('.product-thumbnails-atc-notification-fail');
  const buttonCloseNotification = document.querySelector('.product-thumbnails-atc-add-fail .js-toaster-close');
  const formAddToCart = form.querySelector('.js-cart-add');
  errorMessage.classList.remove('kl-hidden');
  formAddToCart.classList.add('kl-hidden');
  buttonCloseNotification.addEventListener('click', () => {
    errorMessage.classList.add('kl-hidden');
  });
}
class ProductThumbnail extends lm.Composant {
  constructor(id) {
    super(id);
    window.THUMBNAIL = window.THUMBNAIL || {};
    window.THUMBNAIL.instances = window.THUMBNAIL.instances || {};
    if (!window.THUMBNAIL.instances.ProductThumbnail) {
      window.THUMBNAIL.instances.ProductThumbnail = this;
      this._init();
      this.initCarousel();
    }
    this.initQuantitySelector();
    return window.THUMBNAIL.instances.ProductThumbnail;
  }
  _init() {
    document.addEventListener('cartSuccess', event => {
      if (event?.detail?.product?.atcForm) {
        handleSuccessMessage(event.detail.product.atcForm);
      }
    });
    document.addEventListener('cartError', event => {
      if (event?.detail?.product?.atcForm) {
        handleErrorMessage(event.detail.product.atcForm);
      }
    });
    document.addEventListener('addToCartBundle', event => {
      if (event?.detail?.containerSelector) {
        addToCartBundle(event.detail.containerSelector, this);
      }
    });
    document.addEventListener('refreshQuantitySelector', event => {
      if (event?.detail?.selectorContainer) {
        const container = document.querySelector(event.detail.selectorContainer);
        if (!container) {
          return;
        }
        this.initQuantitySelector(container);
      }
    });
    document.addEventListener('refreshProductThumbnails', event => {
      if (event?.detail?.selectorContainer) {
        const container = document.querySelector(event.detail.selectorContainer);
        if (!container) {
          return;
        }
        this.initQuantitySelector(container);
      }
    });
    addEvent(document, 'submit', e => addToCart(e.matchingTarget, false, e, this), '.js-thumbnail-add-to-cart-form', this);
    addEvent(document, 'submit', e => addToCart(e.matchingTarget, true, e, this), '.js-thumbnail-add-to-cart-light-form', this);
    addEvent(document, 'click', e => displayQuantitySelector(e.matchingTarget.closest('.o-thumbnail'), false), '.js-quantity-overlay', this);
    addEvent(document, 'click', e => this.handleStandardQuantitySelectorClick(e.matchingTarget), '.js-thumbnail-standard-quantity-selector .js-increase, .js-thumbnail-standard-quantity-selector .js-decrease', this);
    addEvent(document, 'click', () => window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode')), '.js-th-display-availabilities', this);
  }
  initQuantitySelector(container = document) {
    const quantitySelectorsWithoutAtc = container.querySelectorAll('.js-thumbnail-quantity-selector-without-atc');
    for (const quantitySelector of quantitySelectorsWithoutAtc) {
      const quantitySelectorForm = quantitySelector.querySelector('.js-thumbnail-quantity-selector-form');
      const linkedCartForm = quantitySelector.querySelector('.js-thumbnail-add-to-cart-form');
      this.initQuantitySelectorContainer(quantitySelectorForm, linkedCartForm);
    }
    const standardQuantitySelectors = container.querySelectorAll('.js-thumbnail-standard-quantity-selector');
    for (const quantitySelector of standardQuantitySelectors) {
      const quantitySelectorForm = quantitySelector.querySelector('.js-thumbnail-quantity-selector-form');
      const addToCartContainer = quantitySelector.closest('.o-thumbnail__add-to-cart');
      const linkedCartForm = addToCartContainer ? addToCartContainer.querySelector('.js-thumbnail-add-to-cart-form, .js-thumbnail-add-to-cart-light-form') : null;
      this.initQuantitySelectorContainer(quantitySelectorForm, linkedCartForm);
    }
    const quantitySelectorWrappers = container.querySelectorAll('.js-thumbnail-quantity-selector-wrapper');
    for (const wrapperEl of quantitySelectorWrappers) {
      const quantitySelectorForm = wrapperEl.querySelector('.js-thumbnail-quantity-selector-form');
      const linkedCartForm = wrapperEl.querySelector('.js-thumbnail-add-to-cart-form');
      this.initQuantitySelectorContainer(quantitySelectorForm, linkedCartForm, () => {
        const parentEl = wrapperEl.closest('.o-thumbnail');
        const silentQuantitySelectorForm = parentEl ? parentEl.querySelector('.js-thumbnail-standard-quantity-selector .js-thumbnail-quantity-selector-form') : null;
        if (silentQuantitySelectorForm) {
          linkQuantitySelectorValues(silentQuantitySelectorForm, quantitySelectorForm);
        }
      });
    }
  }
  initQuantitySelectorContainer(quantitySelectorForm, linkedCartForm, additional = () => {}) {
    if (quantitySelectorForm && quantitySelectorForm.dataset.quantitySelectorInitialized !== 'true') {
      new QuantityUpdater(quantitySelectorForm, linkedCartForm);
      new QuantitySelector(quantitySelectorForm);
      additional();
      quantitySelectorForm.dataset.quantitySelectorInitialized = 'true';
    }
  }
  handleStandardQuantitySelectorClick(button) {
    const container = button.closest('.js-thumbnail-standard-quantity-selector');
    if (!container) {
      return;
    }
    const thumbnailEl = container.closest('.o-thumbnail');
    const wrapperEl = thumbnailEl ? thumbnailEl.querySelector('.js-thumbnail-quantity-selector-wrapper') : null;
    if (container.dataset.quantitySelectorLoaded === 'true') {
      if (wrapperEl?.classList.contains('kl-hidden')) {
        resetQuantitySelectorVisibility();
        displayQuantitySelector(thumbnailEl, true);
      }
      return;
    }
    const quantitySelectorForm = container.querySelector('.js-thumbnail-quantity-selector-form');
    if (!quantitySelectorForm?.classList.contains('js-silent-mode')) {
      return;
    }
    if (!['double', 'flooring'].includes(quantitySelectorForm.dataset.qsType)) {
      return;
    }
    if (!wrapperEl) {
      return;
    }
    container.dataset.quantitySelectorLoaded = 'true';
    resetQuantitySelectorVisibility();
    displayQuantitySelector(thumbnailEl, true);
  }
  initCarousel(container = document) {
    const carousels = container.querySelectorAll('.js-thumbnail-carrousel');
    if (!carousels) {
      return;
    }
    for (const carousel of carousels) {
      new MediaCarousel(carousel);
    }
  }
}
lm.DOMReady(function () {
  new ProductThumbnail('product-thumbnail');
  window['lazy-loading-bus'].on('fragmentLoaded', () => {
    new ProductThumbnail('product-thumbnail');
  });
});
export default ProductThumbnail;